import react from 'react'

import { getSectionById } from '../../../Assets/TestData/sectionsData'
import { PEN_REMAININGTODAY } from '../..';

interface SectionRemainingToday_Props {
  sectionId: number
}
/**
 * SECTION_REMAININGTODAY
 * @param sectionId Unique identifier for each section.
 * @returns a section of pens for Freeda Location Feeder systems.
 */
export default function SECTION_REMAININGTODAY({ sectionId }: SectionRemainingToday_Props) {
  const section = getSectionById(sectionId);

  // Error throwback if no section number excists
  if (!section) {
    return <div>Section {sectionId} not found</div>;
  }

  const renderContent = () => {
    return section.pens.map(pen => (
      <PEN_REMAININGTODAY
        key={pen.animal?.animalId}
        penId={pen.penId}
      />
    ));
  }

  return (
      <div style={{ width: "fit-content", height: "fit-content" }}>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", width: "fit-content", gap: "10px", borderRadius: "10px", overflow: "hidden" }}>
          {renderContent()}
        </div>
      </div>
  );
}